import React, { useEffect, useState } from "react";
import api from "../../setupAxios";
import { fechaHoraSegES, msgError } from "../../utils";

// Todas las entradas de una persona, con día y hora de España (la más reciente primero).
//   usuario = { id, nombre, email?, username? }
export default function EntradasModal({ usuario, cerrar }) {
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/admin/accesos/usuario/${usuario.id}`).then(({ data }) => setD(data)).catch((e) => setError(msgError(e)));
  }, [usuario.id]);

  return (
    <div className="modal-back" onMouseDown={cerrar}>
      <div className="modal ci-modal-ancho" style={{ maxHeight: "90vh", overflowY: "auto" }} onMouseDown={(e) => e.stopPropagation()}>
        <h3>🚪 Entradas de {usuario.nombre}</h3>
        <p className="muted" style={{ marginTop: 0 }}>{usuario.username || usuario.email} · Hora de España</p>
        {error && <div className="alert alert-error">{error}</div>}
        {!d && !error && <p className="muted">Cargando…</p>}
        {d && (
          <>
            <p><b>{d.total}</b> {d.total === 1 ? "entrada" : "entradas"}</p>
            <div className="tablewrap" style={{ maxHeight: "52vh" }}>
              <table className="t-entradas">
                <thead><tr><th>Nº</th><th>Día y hora</th><th>Dispositivo</th><th>IP</th></tr></thead>
                <tbody>
                  {d.accesos.length === 0 && <tr><td colSpan={4} className="empty">No ha entrado nunca.</td></tr>}
                  {d.accesos.map((a, i) => (
                    <tr key={a.fecha_hora + i}>
                      <td className="num-cell">{d.total - i}</td>
                      <td className="strong" title={a.navegador || ""}>{fechaHoraSegES(a.fecha_hora)}</td>
                      <td>{a.dispositivo}</td>
                      <td className="mono">{a.ip || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
        <div className="modal-actions"><button className="btn btn-primary" onClick={cerrar}>Cerrar</button></div>
      </div>
    </div>
  );
}
